import React from "react";

import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { useField } from "react-final-form";

interface ICustomOneMap {
  referenceSource: string;
  center?: object;
}

const OneMap = ({ center, referenceSource }: ICustomOneMap) => {
  const {
    input: { value },
  } = useField(referenceSource);

  const position: any = [value.LATITUDE, value.LONGITUDE];

  return (
    <MapContainer
      style={{ height: "40vh", width: "100%" }}
      center={value !== "" ? position : center}
      zoom={15}
    >
      <TileLayer
        attribution='<img src="https://www.onemap.gov.sg/web-assets/images/logo/om_logo.png" style="height:20px;width:20px;"/> OneMap | Map data &copy; contributors, <a href="https://www.sla.gov.sg/">Singapore Land Authority</a>'
        url="https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png"
        detectRetina
        maxZoom={19}
        minZoom={11}
      />
      <Marker position={value !== "" ? position : center} />
    </MapContainer>
  );
};

export default OneMap;
